module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "small"
  }, [_c('p', [_c('br'), _c('br'), _vm._v("In the early 1920s, Stalin and a few colleagues were relaxing in Morozovka Park, lying in the grass. One asked: “What’s the best thing in the world?” “Books,” replied one. “There is no greater pleasure than a woman, your woman,” said another. Then Stalin said, “The sweetest thing is to devise a plan, then, being on the alert, waiting in ambush for a goo-oo-ood long time, finding out where the person is hiding. Then catch the person and take revenge!”"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKLOS")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UN")]), _vm._v(", "), _c('i', [_vm._v("Stalin: An Unknown Portrait")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebfb1a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/other.vue
// module id = 69
// module chunks = 0